import { Component, OnInit, Input } from '@angular/core';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';

@Component({
  selector: 'app-edit-merchant-product',
  templateUrl: './edit-merchant-product.component.html'
})
export class EditMerchantProductComponent implements OnInit {

  @Input() product: any; // for data get from the drawer component
  selectedProduct: any;
  buttonLoadingForUpdate = false;
  @Input() productId: any;
  constructor(private drawerRef: NzDrawerRef<string>) { }

  ngOnInit() {
  }
  // To Stop loading and close drawer
  getOnEditData($event) {
    this.buttonLoadingForUpdate = false;
    this.selectedProduct = $event;
    this.drawerRef.close($event);
  }
  // To Close drawer
  close(): void {
    this.drawerRef.close(this.selectedProduct);
  }
}
